<template>
    <div class="home-wrapper flex-height-max">
        <div class="home-wrapper-container">
            <div v-if="progress_bar_percentage > 0">
                <div class="progress">
                    <div class="progress-bar bg-success" role="progressbar" v-bind:style="'width:'+progress_bar_percentage+'%;'" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{progress_bar_text}}</div>
                </div>
                <div style="text-align: left; font-size: 12px;">Setup progress</div>
            </div>
            <template>
                <div class="header-home">
                    ⚠️Conflict detected
                </div>
                <div class="flex-height-max flex-row">
                    <div class="content">
                        <div style="font-size: 16px;">
                            Don’t worry! Our system detected a tracking template applied to your campaigns and ads, and it's conflicting with our integration process. Our support team is already notified about it and will contact you shortly to set up a free session with our dedicated integration specialist.
                        </div>
                        <div class="mt-3">Meanwhile you can try connecting another Google Ads account or exit the setup.</div>
                        <button class="btn btn-success w-100 mt-3" v-on:click="connectAnotherAccount">CONNECT ANOTHER ACCOUNT</button>
                        <button class="btn btn-primary w-100 mt-3" style="margin-bottom: 80px;" v-on:click="goToAccountPage">GO TO DASHBOARD</button>
                    </div>
                    <div class="content-right-side">
                        <img class="right-img" src="/images/undraw_warning_cyit.svg" alt="conflict">
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['progress_bar_percentage', 'progress_bar_text'],
        data: function () {
            return {

            }
        },
        methods: {
            goToAccountPage(){
                window.location = "/account";
            },
            connectAnotherAccount(){
                window.location = "/setup/connectGoogleAds";
            },
        },
        mounted() {

        }
    }
</script>
